import { WmsfOrderReferences } from '../WmsfOrderReferences/WmsfOrderReferences';

export default class ServiceItem extends WmsfOrderReferences {
  value: number;
  additionalInformation: string;
  sequence: number;

  public constructor() {
    super();
    this.additionalInformation = '';
    this.value = 0;
    this.sequence = 0;
  }
}
